import { OUT_OF_PARITY_HEALTHY_THRESHOLD } from './constants';
import { ParityAnalysis } from './types';

export function isParityHealthy(analysis: ParityAnalysis): boolean {
  return analysis.parityRating === 'GOOD' && analysis.outOfParityCount <= OUT_OF_PARITY_HEALTHY_THRESHOLD;
}

export function fmtShortDate(d: string): string {
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-AU', { month: 'short', day: 'numeric' });
}

export function fmtMonthHeader(d: string): string {
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-AU', { month: 'short', year: 'numeric' });
}
